module.exports = __webpack_public_path__ + "static/media/refil-bliss.d3e57ace.webp";